// extracted by mini-css-extract-plugin
module.exports = {"root":"load-more_root__OopMH"};